import React from "react";
import styled from "styled-components";
import Modal from "~/components/modal";
import _ from "lodash";
import Divider from "~/components/divider";
import ImageAuth from "~/components/image";

const Container = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  row-gap: 15px;
`;

export const ContainerImage = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  img {
    object-fit: fill;
    max-width: 90%;
    height: auto;
  }
`;

export const ProtocolCOVIDModal = ({
  data,
  title,
  isOpen,
  closeModal,
  width = "80%",
  height = "80%",
}) => {
  const srcVaccinationCertificate = _.get(
    data,
    "employee.person.vaccinationCertificate"
  );
  const srcCheckUpPCR = _.get(data, "employee.person.checkUpPCR");
  const personId = _.get(data, "employee.person.id");

  return (
    <Modal
      width={width}
      height={height}
      hideClose={true}
      open={isOpen}
      hide={closeModal}
      title={title}
      actions={[
        {
          label: "Fechar",
          action: closeModal,
        },
      ]}
    >
      <Container>
        {srcVaccinationCertificate && (
          <>
            <Divider label="Certificado de vacinação" />

            <ContainerImage>
              <ImageAuth
                rotate={true}
                withoutLoading={false}
                src={
                  srcVaccinationCertificate
                  ? `/persons/photo/${personId}/vaccinationCertificate`
                  : ""
                }
                />
            </ContainerImage>
          </>
        )}

        {srcCheckUpPCR && (
          <>
            <Divider label="Exame PCR" />

            <ContainerImage>
              <ImageAuth
                rotate={false}
                withoutLoading={true}
                src={
                  srcCheckUpPCR ? `/persons/photo/${personId}/checkUpPCR` : ""
                }
              />
            </ContainerImage>
          </>
        )}
      </Container>
    </Modal>
  );
};
